import { render } from "./reporterApplySchoolQuery.vue?vue&type=template&id=6e9d7240&scoped=true"
import script from "./reporterApplySchoolQuery.vue?vue&type=script&lang=js"
export * from "./reporterApplySchoolQuery.vue?vue&type=script&lang=js"

import "./reporterApplySchoolQuery.vue?vue&type=style&index=0&id=6e9d7240&lang=less&scoped=true"
import "./reporterApplySchoolQuery.vue?vue&type=style&index=1&id=6e9d7240&lang=css"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e9d7240"]])

export default __exports__